import { __assign } from "tslib";
import React from 'react';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import { useDropdownToggleProps } from '../../hooks/useDropdownToggleProps';
/**
 * A wrapper around our DS `IconButton` that provides the props for a dropdown toggle.
 *
 * Note: This component is only the toggle! It doesn't contain a popover or dropdown. If you're looking for something that does,
 * you probably want a preset instead of this. Consider `IconButtonWithContextMenu`.
 *
 * Required contexts: `PopperDropdownContext`, `DropdownStateContext`
 */
var PopperIconToggleButton = function (props) {
    var necessaryToggleProps = useDropdownToggleProps();
    return React.createElement(IconButton, __assign({}, necessaryToggleProps, props));
};
PopperIconToggleButton.displayName = 'PopperIconToggleButton';
export default PopperIconToggleButton;
//# sourceMappingURL=PopperIconToggleButton.js.map